import React from 'react';

export interface FormBehavior {
  renderHeader?: (props: any) => React.ReactElement | null;
  getTemplate?: (templateData: any, isAltView: boolean) => string;
  getInitialData?: (props: any) => any;
  customActions?: Array<{
    label: string;
    action: (props: any) => void;
    variant?: 'primary' | 'secondary' | 'danger';
  }>;
  supportsAltTemplate?: boolean;
  customLogic?: {
    onBeforeCreate?: (data: any) => any;
    onBeforeUpdate?: (data: any) => any;
    onAfterLoad?: (data: any) => any;
  };
}

class FormBehaviorRegistry {
  private behaviors: Map<string, FormBehavior> = new Map();

  register(formType: string, behavior: FormBehavior) {
    this.behaviors.set(formType, behavior);
  }

  get(formType: string): FormBehavior | undefined {
    return this.behaviors.get(formType);
  }

  has(formType: string): boolean {
    return this.behaviors.has(formType);
  }

  getRegisteredTypes(): string[] {
    return Array.from(this.behaviors.keys());
  }
}

export const FormRegistry = new FormBehaviorRegistry();